import axios from 'axios';
import configBase from './configBase';

// Chaves da sessão do painel (as mesmas gravadas em Entrar e limpas em Sair)
const SESSION_KEYS = ['planos_t', 'planos_u', 'planos_y', 'planos_n', 'planos_i'];

// Cliente sem interceptor, para a checagem do token não cair em recursão
const probeClient = axios.create();

let handling = false;

function isLoginRequest(url) {
  return typeof url === 'string' && url.indexOf('Accounts/login') >= 0;
}

function endSession() {
  for (let i = 0; i < SESSION_KEYS.length; i++)
    window.localStorage.removeItem(SESSION_KEYS[i]);

  window.location.href = `${process.env.PUBLIC_URL}/entrar?sessao=expirada`;
}

/*
* O LoopBack responde 401 tanto para token expirado quanto para falta de
* permissão do perfil (ex.: BROKER chamando um endpoint restrito a ADMIN).
* Antes de derrubar a sessão, confirmamos com um endpoint que exige apenas
* usuário autenticado: se ele também recusar, o token é que não vale mais.
*/
function tokenAindaVale(token) {
  let filter = encodeURIComponent('{"limit":1}');

  return probeClient.get(configBase.api + 'Dependents?filter=' + filter + '&access_token=' + token)
  .then(() => true)
  .catch((err) => {
    if (err && err.response && err.response.status === 401)
      return false;

    // Erro de rede ou instabilidade: não é motivo para deslogar
    return true;
  });
}

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    let status = error && error.response ? error.response.status : null;
    let url = error && error.config ? error.config.url : '';

    if (status !== 401 || isLoginRequest(url) || handling)
      return Promise.reject(error);

    let token = window.localStorage.getItem('planos_t');

    // Sem token guardado não há o que confirmar
    if (!token) {
      handling = true;
      endSession();

      return Promise.reject(error);
    }

    handling = true;

    return tokenAindaVale(token)
    .then((vale) => {
      if (!vale)
        endSession();
      else
        handling = false;

      return Promise.reject(error);
    });
  }
);
